import { AnyAction } from '@reduxjs/toolkit'
import { LoginCurve } from 'iconsax-react'
import * as Sentry from '@sentry/react'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React, { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import useSound from 'use-sound'
import {
  fetchInitialDataRequest,
  postGameCodeRequest,
} from '../../../redux/actions/gameActions'
import { showErrorNotification } from '../../../redux/actions/notificationActions'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import { useTranslation } from 'react-i18next'
import client from '../../../client'
import Loading from '../../../components/Loading'

const LoginTeam = () => {
  const [gameCodeValue, setGameCodeValue] = useState('')
  const [isLoadingLogout, setIsloadingLogout] = useState(true)
  const {
    loading: gameLoading,
    data: { volumeGlobal, initialData },
  }: GameState = useSelector(getGameSelector)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })

  useEffect(() => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''

    const logoutPlayer = async () => {
      await client
        .post('Team/LogoutPlayer', null, {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        })
        .then(() => {
          localStorage.removeItem('tokenCityHunt')
          window.location.reload()
        })
    }
    if (token) {
      logoutPlayer().catch((err) => {
        Sentry.captureException(err)
        localStorage.removeItem('tokenCityHunt')
        window.location.reload()
      })
    } else {
      setIsloadingLogout(false)
    }

    dispatch(fetchInitialDataRequest(window.location.href))
  }, [])

  const handleSubmitCode = () => {
    clickSound()
    if (gameCodeValue !== '') {
      dispatch(postGameCodeRequest({ gameCode: gameCodeValue, navigate }))
    } else {
      dispatch(showErrorNotification(t('GameCodeCannotBeEmpty')))
    }
  }
  if (isLoadingLogout || gameLoading.isLoadingInitialData) {
    return <Loading />
  }

  return (
    // <div
    //   className="px-4 py-8 md:px-6 lg:px-8"
    //   style={{ background: 'var(--primary-color)' }}
    // >
    // <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <div className="flex align-items-center justify-content-center">
      <div
        className="w-full flex flex-column align-items-center lg:w-3"
        style={{
          height: window.innerHeight,
          backgroundColor: initialData?.branding?.headerBackgroundColor,
        }}
      >
        {/* <button
          type="button"
          onClick={() => {
            throw new Error('Sentry Test Error 3')
          }}
        >
          Break the world
        </button> */}
        {/* <div className="mb-5 flex flex-column text-center"> */}
        <img
          src={initialData?.logoUrl}
          alt="Game"
          // height={200}
          width="60%"
          className="text-center fadeinleft animation-duration-1000"
          style={{ marginBottom: '5rem' }}
        />
        {/* </div> */}

        <div
          style={{
            // width: '90%',
            // borderTopRightRadius: '50%',
            // borderTopLeftRadius: '50%',
            borderTopLeftRadius: '27px',
            borderTopRightRadius: '27px',
            marginTop: '-20%',
            backgroundColor: initialData?.branding?.textBackgroundColor,
            height: '100%',
            // padding: '4vw',
            width: '100%',
          }}
          className="flex flex-column align-items-center p-4"
        >
          <h3
            className="mb-3 text-center fadeindown animation-duration-1000"
            style={{
              color: initialData?.branding?.welcome.color,
              marginTop: '5rem',
            }}
          >
            {initialData?.branding?.welcome.mainText}
          </h3>
          <p
            className="text-600 font-medium line-height-3 text-center fadeindown animation-duration-1000"
            style={{ color: initialData?.branding?.welcome.color }}
          >
            {initialData?.branding?.welcome.belowText}
          </p>
          {/* <label htmlFor="email" className="block text-900 font-medium mb-2">
              GAME CODE
            </label> */}
          <input
            id="game-code"
            type="text"
            value={gameCodeValue}
            onChange={(e) => setGameCodeValue(e.target.value)}
            placeholder={initialData?.branding?.input.placeholder}
            className="w-full mb-4 zoominleft animation-duration-1000 pl-4"
            style={{
              background: initialData
                ? `${initialData?.branding?.input.backgroundColor} !important`
                : '#fff',
              border: 'none',
            }}
          />

          <Button
            onClick={handleSubmitCode}
            label={initialData?.branding?.button.text}
            loading={gameLoading.isCheckingGameCode}
            // icon={<LoginCurve color="#fff" variant="Bold" className="mr-1" />}
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor:
                      initialData?.branding?.button[
                        initialData?.branding?.button.type
                      ].textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <LoginCurve
                  color={
                    initialData?.branding?.button[
                      initialData?.branding?.button.type
                    ].backgroundColor
                  }
                  variant="Bold"
                  className="icon-center"
                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            className="w-full white-input zoominleft animation-duration-1000 p-button-rounded uppercase"
            // className="w-full sign-in-btn zoominleft animation-duration-1000 p-button-rounded"
            style={{
              color:
                initialData?.branding?.button[
                  initialData?.branding?.button.type
                ].textColor,
              backgroundColor:
                initialData?.branding?.button[
                  initialData?.branding?.button.type
                ].backgroundColor,
              border:
                initialData?.branding?.button.type === 'outlined'
                  ? `2px solid ${
                      initialData?.branding?.button[
                        initialData?.branding?.button.type
                      ].borderColor
                    }`
                  : 'none',
            }}
          />
        </div>
      </div>
    </div>
    // </Sentry.ErrorBoundary>
  )
}

export default LoginTeam
